/*
 Ficheiro inicial JS
 Neste ficheiro apenas devem ser feitos imports de ficheiros por função
 */

// Namespace
var pd = {};

// Aparentemente jQuery está em noConflict()
var $ = jQuery;


//lazy
//=require lazy/*.js

// Componentes
//=require _bootstrap.js
//=require _jQuery.equalHeights.js
//=require _slider.js
//=require _jquery.cycleText.min.js
//=require _jquery.jcarousellite-1.0.1.js
//=require _dg.js
//=require _jquery.bxslider.js
//=require _footer.js




